var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "details-toggle-btn",
      class: { expanded: _vm.expanded },
      on: { click: _vm.toggleShowLess }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.$t("show_less")))]),
      _vm._v(" "),
      _c("angleDownCircled", {
        class: { expanded: _vm.expanded },
        attrs: { color: "#2168BC" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-896c052e", { render: render, staticRenderFns: staticRenderFns })
  }
}